import React from 'react';

export const roundTo = (num, digits = 0) => {
  const factor = 10 ** -digits;
  return Math.round(num / factor) * factor;
};

export const currencyFormatter = (amount, precision = 0) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: precision,
  });
  return formatter.format(amount);
};

export const Money = ({ amount, precision, round }) => (
  <span>{currencyFormatter(round ? roundTo(amount, round) : amount, precision || 0)}</span>
);
